import React, { useState } from "react";
import { Smile } from "lucide-react";
import { Popover } from "./Popover";

const GROUPS: { name: string; emojis: string }[] = [
  { name: "Smileys", emojis: "😀😃😄😁😆😅😂🤣😊🙂😉😍🥰😘😋😎🤩🥳😇🤗🤔🤨😐😶🙄😏😴😌😛😜🤪😝🤤😒😓😔😕🙃🤑😲🙁😖😞😟😤😢😭😦😧😨😩🤯😬😰😱🥵🥶😳🤒🤕🤢🤮🤧😷" },
  { name: "Gestures", emojis: "👍👎👌✌️🤞🤟🤘🤙👈👉👆👇☝️✋🤚🖐️🖖👋🤝🙏✍️💪👏🙌👐🤲" },
  { name: "Hearts", emojis: "❤️🧡💛💚💙💜🖤🤍🤎💔❣️💕💞💓💗💖💘💝" },
  { name: "Work", emojis: "✅☑️✔️❌❎⚠️📌📍📎🖇️📏📐✂️🗂️📁📂📅📆🗓️📇📈📉📊📋📝✏️🖊️💼🧾💰💵💳🏦🏭🚚📦📮📞☎️📱💻🖨️⏰⏳⌛🔔🎯🏆🎉🎊" },
  { name: "Textile", emojis: "🧵🧶👕👔👗👚👖🧥🥼🦺🧣🧤🧦👘🥻🩳🎽🛍️🏷️🪡🧺" },
  { name: "Symbols", emojis: "⭐🌟✨⚡🔥💯🆗🆕🆓🔝🔴🟠🟡🟢🔵🟣⚫⚪➕➖✖️➗❓❗‼️⁉️💬💭🕐🌙☀️🌧️" },
];

// Split into user-perceived characters (keeps ❤️ / 👍🏽 as one emoji)
const split = (s: string) =>
  typeof Intl !== "undefined" && "Segmenter" in Intl
    ? Array.from(new (Intl as any).Segmenter("en", { granularity: "grapheme" }).segment(s), (x: any) => x.segment as string)
    : Array.from(s);

/** Small emoji picker for the chat box */
export function EmojiPicker({ onPick, disabled }: { onPick: (emoji: string) => void; disabled?: boolean }) {
  const [group, setGroup] = useState(0);
  return (
    <Popover
      trigger={
        <span
          className="size-10 shrink-0 rounded-full flex items-center justify-center hover:bg-black/5 dark:hover:bg-white/5"
          style={{ color: "var(--wa-muted)" }}
          title="Emoji"
          aria-label="Emoji"
        >
          <Smile className="size-6" />
        </span>
      }
      disabled={disabled}
    >
      <div className="w-[300px]">
        <div className="flex gap-1 border-b pb-1.5 mb-1.5 overflow-x-auto">
          {GROUPS.map((g, i) => (
            <button
              key={g.name}
              type="button"
              onClick={() => setGroup(i)}
              className={`text-[11px] px-2 py-0.5 rounded-full whitespace-nowrap ${i === group ? "bg-[#d9fdd3] text-[#008069] dark:bg-[#0a332c] dark:text-[#00a884]" : "text-muted-foreground hover:bg-muted"}`}
            >
              {g.name}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-8 gap-0.5 max-h-52 overflow-y-auto">
          {split(GROUPS[group]!.emojis).map((e, i) => (
            <button key={`${e}-${i}`} type="button" onClick={() => onPick(e)} className="text-xl leading-none p-1 rounded hover:bg-muted" aria-label={`Insert ${e}`}>
              {e}
            </button>
          ))}
        </div>
      </div>
    </Popover>
  );
}
